import getConfig from 'next/config';
import {
  setIsMarginPair,
} from '../actions/load';
import { shouldUseAltWssUrl } from '../utils/urlUtils';
import {
  fetchMarginCoeff,
  fetchMarginSymbols,
  setMarginCoeff,
  setMarginSymbols,
} from '../actions/actionsSet/margin';

const {
  publicRuntimeConfig: {
    mktdataWssUrl: WSS_URL,
    altSiteWssUrl: ALT_WSS_URL,
    enableMargin,
  },
} = getConfig();


// margin
export const handleMarginSymbolsTask = (store, req, both) => {
  if (!enableMargin) return {};
  return fetchMarginSymbols(req)
    .then(symbols => {
      store.dispatch(setMarginSymbols(symbols));
      if (Array.isArray(both)) { // trade page
        symbols.filter(k => k.base === both[0])
          .filter(m => m.quote === both[1]).length ?
          store.dispatch(setIsMarginPair(true)) : store.dispatch(setIsMarginPair(false));
      }
    });
};

export const handleMarginCoeffTask = (store, req) => {
  if (!enableMargin) return {};
  return fetchMarginCoeff(req)
    .then(coeff => store.dispatch(setMarginCoeff(coeff)));
};

export const wssUri = req => shouldUseAltWssUrl(req) ? ALT_WSS_URL : WSS_URL;
